"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ui = require("@unite-us/ui");
var _draftJs = require("draft-js");
var _draftJsExportHtml = require("draft-js-export-html");
var _draftJsImportHtml = require("draft-js-import-html");
var _HtmlParsedText = _interopRequireDefault(require("./components/HtmlParsedText"));
var _InlineStyleControls = _interopRequireDefault(require("./components/InlineStyleControls"));
var _BlockStyleControls = _interopRequireDefault(require("./components/BlockStyleControls"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote':
      return 'RichEditor-blockquote';
    default:
      return null;
  }
}
var DraftEditorField = /*#__PURE__*/function (_Component) {
  _inherits(DraftEditorField, _Component);
  var _super = _createSuper(DraftEditorField);
  function DraftEditorField(props) {
    var _this;
    _classCallCheck(this, DraftEditorField);
    _this = _super.call(this, props);

    // We want to initialize the editor with either the field value or the props value,
    // if it is from the props, it is a readOnly display, or a fall back of an empty string
    var contentState = (0, _draftJsImportHtml.stateFromHTML)((0, _ui.getPreferredProp)(props, 'value') || '');
    _this.state = {
      editorState: _draftJs.EditorState.createWithContent(contentState)
    };
    _this.editorInstance = null;
    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.handleKeyCommand = _this.handleKeyCommand.bind(_assertThisInitialized(_this));
    _this.toggleBlockType = _this.toggleBlockType.bind(_assertThisInitialized(_this));
    _this.toggleInlineStyle = _this.toggleInlineStyle.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(DraftEditorField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var nextValue = (0, _ui.getPreferredProp)(nextProps, 'value');
      var currentValue = (0, _ui.getPreferredProp)(this.props, 'value');
      if (nextProps.readOnly && nextValue !== currentValue) {
        var contentState = (0, _draftJsImportHtml.stateFromHTML)(nextValue);
        this.setState({
          editorState: _draftJs.EditorState.createWithContent(contentState)
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(editorState) {
      // When the editor's content changes, we need to keep the editorState current
      // as well as the field's value.
      var changeCallback = (0, _ui.getPreferredProp)(this.props, 'onChange');
      if (changeCallback) {
        var value = (0, _draftJsExportHtml.stateToHTML)(editorState.getCurrentContent());
        changeCallback(value);
      }
      this.setState({
        editorState: editorState
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      this.editorInstance.focus();
    }
  }, {
    key: "toggleBlockType",
    value: function toggleBlockType(blockType) {
      this.onChange(_draftJs.RichUtils.toggleBlockType(this.state.editorState, blockType));
    }
  }, {
    key: "toggleInlineStyle",
    value: function toggleInlineStyle(inlineStyle) {
      this.onChange(_draftJs.RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle));
    }
  }, {
    key: "handleKeyCommand",
    value: function handleKeyCommand(command) {
      var editorState = this.state.editorState;
      var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);
      if (newState) {
        this.onChange(newState);
        return true;
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var editorState = this.state.editorState;
      var _this$props = this.props,
        dataTestId = _this$props.dataTestId,
        hideError = _this$props.hideError,
        hideLabel = _this$props.hideLabel,
        id = _this$props.id,
        inline = _this$props.inline,
        label = _this$props.label,
        labelStyle = _this$props.labelStyle,
        readOnly = _this$props.readOnly,
        required = _this$props.required,
        spellCheck = _this$props.spellCheck;
      var hasError = (0, _ui.getPreferredProp)(this.props, 'invalid') && (0, _ui.getPreferredProp)(this.props, 'touched');
      var fieldClass = function fieldClass() {
        return (0, _classnames["default"])({
          'ui-form-field': true,
          'ui-draft-editor-field': true,
          'ui-form-field--has-error': hasError,
          'ui-form-field--inline': inline
        });
      };
      var labelClass = function labelClass() {
        return (0, _classnames["default"])({
          'ui-form-field__label': true,
          'sr-only top-0': hideLabel,
          'ui-form-field__label--required': required
        });
      };
      var richEditorClassNames = function richEditorClassNames() {
        return (0, _classnames["default"])({
          'RichEditor-root': true,
          'read-only': readOnly
        });
      };

      // If the user changes block type before entering any text, we can
      // either style the placeholder or hide it. Let's just hide it now.
      var className = 'RichEditor-editor';
      var contentState = editorState.getCurrentContent();
      if (!contentState.hasText()) {
        if (contentState.getBlockMap().first().getType() !== 'unstyled') {
          className += ' RichEditor-hidePlaceholder';
        }
      }
      var editorControls = /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-8"
      }, /*#__PURE__*/_react["default"].createElement(_BlockStyleControls["default"], {
        editorState: editorState,
        onToggle: this.toggleBlockType
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-4"
      }, /*#__PURE__*/_react["default"].createElement(_InlineStyleControls["default"], {
        editorState: editorState,
        onToggle: this.toggleInlineStyle
      })));
      if (readOnly) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: fieldClass()
        }, /*#__PURE__*/_react["default"].createElement("label", {
          className: labelClass(),
          htmlFor: id,
          style: labelStyle
        }, label), /*#__PURE__*/_react["default"].createElement(_HtmlParsedText["default"], {
          value: this.props.value
        }));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: fieldClass()
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: labelClass(),
        htmlFor: id,
        style: labelStyle
      }, label), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: richEditorClassNames()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: className,
        "data-testid": dataTestId,
        onClick: this.focus,
        role: "textbox",
        tabIndex: 0,
        id: id
      }, /*#__PURE__*/_react["default"].createElement(_draftJs.Editor, {
        ref: function ref(c) {
          _this2.editorInstance = c;
        },
        blockStyleFn: getBlockStyle,
        editorState: editorState,
        handleKeyCommand: this.handleKeyCommand,
        onChange: this.onChange,
        spellCheck: spellCheck,
        readOnly: readOnly,
        onBlur: (0, _ui.getPreferredProp)(this.props, 'onBlur'),
        onFocus: (0, _ui.getPreferredProp)(this.props, 'onFocus')
      })), !readOnly && editorControls), !hideError && /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-form-field__error"
      }, (0, _ui.getPreferredProp)(this.props, 'error'))));
    }
  }]);
  return DraftEditorField;
}(_react.Component);
DraftEditorField.propTypes = _objectSpread({
  /** Remove Error element */
  dataTestId: _propTypes["default"].string,
  hideError: _propTypes["default"].bool,
  hideLabel: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  inline: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  labelStyle: _propTypes["default"].object,
  readOnly: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  spellCheck: _propTypes["default"].bool,
  value: _propTypes["default"].string.isRequired
}, _ui.fieldProps);
DraftEditorField.defaultProps = {
  dataTestId: '',
  hideError: false,
  hideLabel: false,
  inline: false,
  inputStyle: {},
  labelStyle: {},
  readOnly: false,
  required: false,
  spellCheck: true
};
var _default = exports["default"] = DraftEditorField;